<style scoped>

  .ui.segment {
    min-height: 250px;
  }

</style>

<template>
  
  <div class="ui grid animated fadeIn">

    <div class="eight wide column">

      <div class="ui segment">
        <h4 class="ui dividing header">Endereço do Cliente</h4>
        <form class="ui form">
          <div class="fields">            
            <div class="sixteen wide field">
              <label class="form-label">Endereço</label>
              <span>{{ customer.address }}</span>
            </div>            
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Bairro</label>
              <span>{{ customer.district }}</span>
            </div>
            <div class="eight wide field">
              <label class="form-label">Município</label>
              <span>{{ customer.city + ' / ' + customer.state }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">CEP</label>
              <span>{{ customer.zipCode }}</span>
            </div>
          </div>
        </form>

      </div>

    </div>

    <div class="eight wide column">

      <div class="ui segment">
        <h4 class="ui dividing header">Endereço de Cobrança</h4>
        <form class="ui form">
          <div class="fields">            
            <div class="sixteen wide field">
              <label class="form-label">Endereço</label>
              <span>{{ customer.billAddress }}</span>
            </div>            
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Bairro</label>
              <span>{{ customer.billDistrict }}</span>
            </div>
            <div class="eight wide field">
              <label class="form-label">Município</label>
              <span v-if="customer.billCity">{{ customer.billCity + ' / ' + customer.billState }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">CEP</label>
              <span v-if="customer.billZipCode && customer.billZipCode.trim() != '-'">{{ customer.billZipCode }}</span>
            </div>
          </div>
        </form>

      </div>

    </div>

  </div>

</template>

<script>

  export default {    
    props: ["customer"],
  }

</script>
